import { Component, Input } from '@angular/core';
import { OrderApiService } from 'src/app/services/api/order-api.service';

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.scss'],
})
export class VerificationCodeComponent {
  @Input() data: any;
  @Input() platform: any;

  constructor(private api: OrderApiService) {}

  code = '';
  timeout2 = 91;

  getCode() {
    if (this.platform === 'PS AI' || this.platform === 'Adobe') {
      this.getPSCode(this.data);
    } else if (
      this.platform === 'ChatGPT Plus' ||
      this.platform === 'ChatGPT' ||
      this.platform === 'ChatGPT Go'
    ) {
      this.getGPTCode(this.data);
    } else if (this.platform === 'Suno国际版') {
      this.getSunoCode(this.data);
    } else if (this.platform === 'Spotify') {
      this.getSpotifyCode();
    } else if (this.platform === 'Disney+') {
      this.getDisneyCode();
    } else if (this.platform === 'Netflix') {
      this.getNetflixCode(this.data);
    }
  }

  async getNetflixCode(data: any) {
    try {
      this.timeout2 = 90;
      await this.api.getLink(data.id, 'netflix');
      if (this.timeout2 > 0) {
        let interval = setInterval(async () => {
          this.timeout2 -= 1;
          const r = await this.api.getSelectLink(data.id, 'netflix');
          if (r.data) {
            this.code = r.data;
            clearInterval(interval);
          }
          if (this.timeout2 === 0) {
            clearInterval(interval);
          }
        }, 1000);
      }
    } catch (error) {}
  }

  async getPSCode(data: any) {
    try {
      this.timeout2 = 90;
      await this.api.getLink(data.id, 'ps');
      if (this.timeout2 > 0) {
        let interval = setInterval(async () => {
          this.timeout2 -= 1;
          const r = await this.api.getSelectLink(data.id, 'ps');
          if (r.data) {
            this.code = r.data;
            clearInterval(interval);
          }
          if (this.timeout2 === 0) {
            clearInterval(interval);
          }
        }, 1000);
      }
    } catch (error) {}
  }

  async getGPTCode(data: any) {
    try {
      this.timeout2 = 90;
      await this.api.getGPTSelectCode(data.id);
      if (this.timeout2 > 0) {
        let interval = setInterval(async () => {
          this.timeout2 -= 1;
          const r = await this.api.getGPTCode(data.id);
          if (r.data) {
            this.code = r.data;
            clearInterval(interval);
          }
          if (this.timeout2 === 0) {
            clearInterval(interval);
          }
        }, 1000);
      }
    } catch (error) {
    } finally {
    }
  }

  async getSunoCode(data: any) {
    try {
      this.timeout2 = 90;
      await this.api.getSunoSelectCode(data.id);
      if (this.timeout2 > 0) {
        let interval = setInterval(async () => {
          this.timeout2 -= 1;
          const r = await this.api.getSunoCode(data.id);
          if (r.data) {
            this.code = r.data;
            clearInterval(interval);
          }
          if (this.timeout2 === 0) {
            clearInterval(interval);
          }
        }, 1000);
      }
    } catch (error) {
    } finally {
    }
  }

  async getSpotifyCode() {
    try {
      this.timeout2 = 90;
      await this.api.getSpotifySelectCode(this.data.id);
      if (this.timeout2 > 0) {
        let interval = setInterval(async () => {
          this.timeout2 -= 1;
          const r = await this.api.getSpotifyCode(this.data.id);
          if (r.data) {
            this.code = r.data;
            clearInterval(interval);
          }
          if (this.timeout2 === 0) {
            clearInterval(interval);
          }
        }, 1000);
      }
    } catch (error) {
    } finally {
    }
  }

  async getDisneyCode() {
    try {
      this.timeout2 = 90;
      await this.api.getDisneySelectCode(this.data.id);
      if (this.timeout2 > 0) {
        let interval = setInterval(async () => {
          this.timeout2 -= 1;
          const r = await this.api.getDisneyCode(this.data.id);
          if (r.data) {
            this.code = r.data;
            clearInterval(interval);
          }
          if (this.timeout2 === 0) {
            clearInterval(interval);
          }
        }, 1000);
      }
    } catch (error) {
    } finally {
    }
  }
}
